let loaclHostPro = process.env.NODE_ENV === 'production'
let _host = loaclHostPro ?  window.location.origin : '/api'
let _localhost = loaclHostPro ? 'https://gy.damaiiot.com' : '/localapi'
let _localWaterapi = loaclHostPro ? 'https://gy.damaiiot.com' : '/localWaterapi'

let httpUrl = {
  'host': _host,
  'localapi': _localhost,
  'localWaterapi': _localWaterapi
}
export {httpUrl}



// WEBPACK FOOTER //
// ./src/view/api/httpUrl.js